import { path, httpService } from '@commons';

/////////////////////////////////////////////////////////////////////////////////
const args = { ...path, path: '/aplicacao/estagio' };
/////////////////////////////////////////////////////////////////////////////////

export function createEstagioAplicacaoCadastro(payload) {
  return httpService.post(args, payload);
}

export function updateEstagioAplicacaoCadastro(payload) {
  const { id } = payload

  return httpService.put({ ...args, args: `/${id}` }, payload);
}

export function listEstagioAplicacaoCadastro(param) {
  return httpService.get({...args, args: param});
}

export function findEstagioAplicacaoCadastro(id) {
  return httpService.get({ ...args, args: `/${id}` });
}

export function deleteEstagioAplicacaoCadastro(id) {
  return httpService.del({ ...args, args: `/${id}` });
}
